import {
    Component,
    OnInit,
    ViewChild
} from '@angular/core';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { GetSharedDocuments, DownloadDocument } from '../_store/resources.actions';
import { debounceTime } from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { filterResults } from "../../../../app.constants";
import { ViewListService } from "../../../../services/list-grid-view.service";
import { LoaderHide, LoaderShow } from 'src/app/features/loader/store/loader.actions';
import { MatTableDataSource } from '@angular/material';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { PAGE_LIMIT } from 'src/app/app.constants';




@Component({
    selector: 'shared-documents',
    templateUrl: './shared-documents.component.html',
    styleUrls: ['./shared-documents.component.scss']
})
export class SharedDocumentsComponent implements OnInit {
    documentList;
    filteredDocuments;
    listView: boolean = false
    searchInput = new FormControl();
    isDataLoaded: boolean = false;
    myFilesPageNumber: number = 1;
    myFilesPages: number = 0;
    dataSource;
    displayedColumns: string[] = ["Name", "Date", "tags","Action"]
    totalPages: number = 0
    currentPage: number = 0
    count: number = 0
    sortBy
    sortOrder;
    limitPerPageOptions;
    pageSizeDefault = '30';
    pageLimit = this.pageSizeDefault;

    @ViewChild('docs', { static: false })
    docs: any;


    

    constructor(
        private store: Store<AppState>,
        private router: Router,
        private viewData: ViewListService,
    ) {
        this.viewData.currentViewMode.subscribe(listViewFlag => this.listView = listViewFlag);

        this.viewData.changeSortOptions('date', 'desc',+this.pageLimit)
        this.viewData.CurrentSortBy.subscribe(sortBy => this.sortBy = sortBy)
        this.viewData.CurrentSortOrder.subscribe(sortOrder => this.sortOrder = sortOrder)
    }

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    ngOnInit() {
        this.limitPerPageOptions = PAGE_LIMIT;
        this.store.dispatch(new GetSharedDocuments({ page: this.myFilesPageNumber, limit:  this.pageLimit, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
        this.store.select(state => state.resources.sharedDocuments).pipe().subscribe((response: any) => {
            this.documentList = response.docList;
            this.filteredDocuments = response.docList;

            //this.dataSource = new MatTableDataSource(this.documentList)

            this.dataSource = [...this.documentList];

            this.myFilesPageNumber = response.details.page;
            this.myFilesPages = response.details.pages;
            this.isDataLoaded = response.loaded;
            this.store.dispatch(new LoaderHide());

            this.totalPages = response.details.pages;
            this.currentPage = response.details.page;
            this.count = response.details.total;

            this.pageLimit = this.pageSizeDefault;

            if (this.docs) {
                this.docs.nativeElement.scrollTop = 0;
            }

        });

        /* listening to search input */
        this.searchInput.valueChanges.pipe(debounceTime(1000)).subscribe(searchString => {
            this.filteredDocuments = filterResults(this.documentList, searchString);
        });
    }

    onScroll(event) {
        const divViewHeight = event.target.offsetHeight; // viewport: ~500px
        const divScrollHeight = event.target.scrollHeight; // length of all table
        const scrollLocation = event.target.scrollTop; // how far user scrolled
        const buffer = 0;
        const limit = divScrollHeight - divViewHeight - buffer;

        //for my messages
        if (scrollLocation >= limit) {
            if (this.myFilesPageNumber < this.myFilesPages) {
                this.myFilesPageNumber++;
                this.store.dispatch(new LoaderShow());
                this.store.dispatch(new GetSharedDocuments({ 'page': this.myFilesPageNumber, 'limit': 30 }));
            }
        }
    }

    getServerData(event?: PageEvent) {
        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new GetSharedDocuments({ 'page': event, 'limit':  this.pageLimit, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
    }

    setPage(page) {
        console.log(page);
        if (page <= this.totalPages) {
            this.store.dispatch(new GetSharedDocuments({ 'page': page, 'limit': 30, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));

        }


    }
    downloadDocument(docObj) {
        this.store.dispatch(new DownloadDocument(docObj._id, docObj.fileName));
      }

    onDocClick(document) {
        if (document) {
          this.router.navigate(['./home/resources/doc/' + document._id]);
        }
    }

    onChange(event) {
        this.viewData.changeSortOptions(this.sortBy,this.sortOrder, event.value)

        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new GetSharedDocuments({ 'page': 1, 'limit':  event.value, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
    }

}
